module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company"
  }, [_c('div', {
    staticClass: "company-content"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "content-breadcrumb cp"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_c('a', {
    attrs: {
      "href": "/company"
    }
  }, [_vm._v("公司动态和市场活动")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.breadcrumbTitle))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('div', {
    staticClass: "content-title clearfix"
  }, _vm._l((_vm.titleCon), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "title-content cp",
      class: {
        IsClick: _vm.clickTitle === item.id
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "content-details clearfix"
  }, [_c('div', {
    staticClass: "details-dynamic clearfix"
  }, [_c('div', {
    staticClass: "details-dynamic-left"
  }, [_c('div', {
    staticStyle: {
      "width": "700px"
    }
  }, [_c('h1', {
    staticClass: "details-content-title"
  }, [_vm._v(_vm._s(_vm.detailsCon.title))]), _vm._v(" "), _c('span', {
    staticClass: "details-content-time"
  }, [_vm._v("发布时间:" + _vm._s(_vm.detailsCon.year))]), _vm._v(" "), _c('div', {
    staticClass: "details-content-content",
    domProps: {
      "innerHTML": _vm._s(_vm.detailContent)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-dynamic-right"
  }, [_c('h1', {
    staticClass: "dynamic-right-title"
  }, [_vm._v("动态推荐")]), _vm._v(" "), _c('div', {
    staticClass: "dynamic-right-box"
  }, _vm._l((_vm.diyCon), function(item) {
    return _c('a', {
      staticClass: "details-bottom-box cp db",
      attrs: {
        "href": _vm.diyClick(item.id),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "bottom-box-img"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.img),
        expression: "$global.globalPath + item.img"
      }],
      staticStyle: {
        "width": "300px",
        "height": "200px",
        "border-radius": "5px"
      },
      attrs: {
        "alt": "动态推荐"
      }
    })]), _vm._v(" "), _c('h2', {
      staticClass: "bottom-box-span"
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)])]), _vm._v(" "), _c('div')])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c316d94"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutUs/companyDetail.vue
// module id = 635
// module chunks = 12